module.exports = __webpack_public_path__ + "static/1 (1)-8be5df3baf13185ba7f7f8986fc4101a.jpg";